/* [BD] Anwendung media slider — bd-anwendung.liquid */
;(function () {
  function updateBdAnwendungActiveSlide(slider) {
    if (!slider) return;
    var slides = slider.querySelectorAll('.bd-anwendung__media-slide');
    if (!slides.length) return;

    if (!window.matchMedia('(max-width: 749px)').matches) {
      slides.forEach(function (s) {
        s.classList.remove('bd-anwendung__media-slide--is-active');
      });
      return;
    }

    if (slides.length < 2) {
      slides.forEach(function (s) {
        s.classList.add('bd-anwendung__media-slide--is-active');
      });
      return;
    }

    var rect = slider.getBoundingClientRect();
    var centerX = rect.left + rect.width / 2;
    var closest = null;
    var closestDist = Infinity;

    slides.forEach(function (slide) {
      var r = slide.getBoundingClientRect();
      var slideCenter = r.left + r.width / 2;
      var d = Math.abs(slideCenter - centerX);
      if (d < closestDist) {
        closestDist = d;
        closest = slide;
      }
    });

    slides.forEach(function (slide) {
      slide.classList.toggle('bd-anwendung__media-slide--is-active', slide === closest);
    });
  }

  function initBdAnwendungMediaSlider(slider) {
    if (!slider) return;

    if (slider._bdAnwendungScrollHandler) {
      slider.removeEventListener('scroll', slider._bdAnwendungScrollHandler);
    }

    var scrollTicking = false;
    function onScroll() {
      if (!scrollTicking) {
        scrollTicking = true;
        requestAnimationFrame(function () {
          scrollTicking = false;
          updateBdAnwendungActiveSlide(slider);
        });
      }
    }
    slider._bdAnwendungScrollHandler = onScroll;
    slider.addEventListener('scroll', onScroll, { passive: true });

    var slides = slider.querySelectorAll('.bd-anwendung__media-slide');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (!isMobile) {
      slides.forEach(function (s) {
        s.classList.remove('bd-anwendung__media-slide--is-active');
      });
      return;
    }

    if (slides.length < 2) {
      updateBdAnwendungActiveSlide(slider);
      return;
    }

    var main = slider.querySelector('.bd-anwendung__media-slide--main');
requestAnimationFrame(function () {
  if (main) {
    // Only move the media slider horizontally.
    // Do NOT use scrollIntoView because it scrolls the page vertically on mobile.
    var sliderRect = slider.getBoundingClientRect();
    var mainRect = main.getBoundingClientRect();

    var currentLeft = slider.scrollLeft;
    var targetLeft =
      currentLeft +
      (mainRect.left - sliderRect.left) -
      (sliderRect.width / 2) +
      (mainRect.width / 2);

    slider.scrollTo({
      left: targetLeft,
      behavior: 'auto'
    });
  }

  requestAnimationFrame(function () {
    updateBdAnwendungActiveSlide(slider);
  });
});
  }

  function initBdAnwendungMediaSliders(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-bd-anwendung-media-slider]').forEach(initBdAnwendungMediaSlider);
  }

  var bdAnwendungResizeTimer;
  function scheduleBdAnwendungMediaSliders() {
    clearTimeout(bdAnwendungResizeTimer);
    bdAnwendungResizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-bd-anwendung-media-slider]').forEach(initBdAnwendungMediaSlider);
    }, 150);
  }

  if (!window.__bdAnwendungResizeBound) {
    window.__bdAnwendungResizeBound = true;
    window.addEventListener('resize', scheduleBdAnwendungMediaSliders);
  }

  function boot(scope) {
    initBdAnwendungMediaSliders(scope || document);
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode && !window.__bdSectionAnwendungDesignMode) {
    window.__bdSectionAnwendungDesignMode = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
  }
})();
